export enum OperatorScopeType {
    User = 0,
    Web = 1,
    Team = 2
}
